import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { connect, useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ArticleIcon from '@mui/icons-material/Article';
import Tooltip from '@mui/material/Tooltip';
import {
  addScreen,
  checkQuestion,
  setCurrentScreen,
  updateFormConfigs,
  // updateFormSettings,
  updateThemeConfig,
} from "../actions";

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: "20px",
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    bottom: 0,
    // left: "300px",
    // right: "450px",
    position: "sticky",
    display: "flex",
    zIndex: "1",
    width:"100%"
  }
}));

const Footer = (props) => {
  const { pages, current_page, form_configs } = useSelector((state) => ({
    pages: state.pages,
    current_page: state.current_page,
    form_configs: state.form_configs
  }));
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleAddScreen = () => {
    const page_number = Object.keys(pages).length;
    const last_index = Object.keys(pages)[page_number - 1];
    const new_page_name = parseInt(last_index) + 1;
    dispatch(addScreen(new_page_name));
    // dispatch(toggleDrawer("questionConfig", true));
    dispatch(checkQuestion(new_page_name));
  };
  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" style={{flexDirection:"row", borderRadius:"4px"}}>
        {
          !props.previewForm && form_configs['show_welcome_screen'] == '0' ?
          <Tooltip title="Add welcome screen">
            <Button
              variant="text"
              color="primary"
              className={classes.button}
              onClick={() =>{
                dispatch(updateFormConfigs('show_welcome_screen','1'))
                dispatch(updateThemeConfig('show_welcome_screen','1'))
                setTimeout(()=>{
                  dispatch(setCurrentScreen('welcome'));
                  dispatch(checkQuestion('welcome'));
                },200)
              }}
            >
              <PostAddIcon/>
            </Button>
          </Tooltip>
           :
            <Tooltip title="Welcome screen">
              <Button
                variant="text"
                color="primary"
                className={classes.button}
                onClick={() =>{
                  dispatch(setCurrentScreen('welcome'));
                  dispatch(checkQuestion('welcome'));
                }}
              >
                <ArticleIcon/>
              </Button>
            </Tooltip>
        }
        <Tabs
          key={`current_page${current_page - 1}`}
          value={Object.keys(pages).indexOf(current_page + "")}
          onChange={(e, newValue) => {
            const page_name = Object.keys(pages)[newValue];
            dispatch(setCurrentScreen(page_name));
            // dispatch(toggleDrawer("questionConfig", true));
            dispatch(checkQuestion(page_name));
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {Object.keys(pages).map((page, index) => {
            return (
              <Tab
                key={`page${page}${index}`}
                label={page}
                {...a11yProps(page)}
                style={{width:"50px"}}
              />
            )
          })}
        </Tabs>
        {
          !props.previewForm &&
          <Tooltip title="Add new screen">
            <Button
              variant="text"
              color="primary"
              className={classes.button}
              onClick={handleAddScreen}
            >
              <LibraryAddIcon/>
            </Button>
          </Tooltip>
        }
      </AppBar>
      
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Footer);
